import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[(_vm.showBack)?_c('div',{staticClass:"login-wrapper__header"},[_c('router-link',{attrs:{"to":"/login"}},[_c(VIcon,[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.$t("loginPage.back"))+" ")],1)],1):_vm._e(),_vm._t("default"),_c('f-language-selector')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }